import { render, staticRenderFns } from "./ButtonDown.vue?vue&type=template&id=52119a6b&scoped=true"
import script from "./ButtonDown.vue?vue&type=script&lang=js"
export * from "./ButtonDown.vue?vue&type=script&lang=js"
import style0 from "./ButtonDown.vue?vue&type=style&index=0&id=52119a6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52119a6b",
  null
  
)

export default component.exports